"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Contract_Asset = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_Coding_1 = require("./RTTI_Coding");
var RTTI_Contract_Context_1 = require("./RTTI_Contract_Context");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Contract_Answer_1 = require("./RTTI_Contract_Answer");
var RTTI_unsignedInt_1 = require("../Scalar/RTTI_unsignedInt");
var RTTI_Contract_ValuedItem_1 = require("./RTTI_Contract_ValuedItem");
exports.RTTI_Contract_Asset = t.recursion('IContract_Asset', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        scope: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        type: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        typeReference: t.array(RTTI_Reference_1.RTTI_Reference),
        subtype: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        relationship: RTTI_Coding_1.RTTI_Coding,
        context: t.array(RTTI_Contract_Context_1.RTTI_Contract_Context),
        condition: t.string,
        _condition: RTTI_Element_1.RTTI_Element,
        periodType: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
        period: t.array(RTTI_Period_1.RTTI_Period),
        usePeriod: t.array(RTTI_Period_1.RTTI_Period),
        text: t.string,
        _text: RTTI_Element_1.RTTI_Element,
        linkId: t.array(t.string),
        _linkId: t.array(RTTI_Element_1.RTTI_Element),
        answer: t.array(RTTI_Contract_Answer_1.RTTI_Contract_Answer),
        securityLabelNumber: t.array(RTTI_unsignedInt_1.RTTI_unsignedInt),
        _securityLabelNumber: t.array(RTTI_Element_1.RTTI_Element),
        valuedItem: t.array(RTTI_Contract_ValuedItem_1.RTTI_Contract_ValuedItem)
    });
});
//# sourceMappingURL=RTTI_Contract_Asset.js.map